module.exports = __webpack_public_path__ + "img/b7741ba.png";